import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import sortNumeral from '@/root/utils/helpers/sortNumeral'
import { useMatchLog } from '@/root/context/MatchContext'
// Internal components

const PlayerTimer = (props) => {
  const { player, matchLength } = props

  const playerTimerRef = useRef()

  const { currentLineUp, initialLineUp } = useMatchLog()

  const playerWithTime = initialLineUp.find((initialPlayer) => initialPlayer.uuid === player.uuid)

  const [hasHighTime, setHasHighTime] = useState(false)

  // Add logic to change color of the three highest playing time players
  useEffect(() => {
    const sortedArray = sortNumeral(initialLineUp, true, 'playingTime')
    const highestPlayersArr = [...sortedArray].splice(0, 4)
    const playerTimes = []
    highestPlayersArr.forEach((player) => {
      playerTimes.push(player.playingTime)
    })
    const uniquePlayingTime = new Set(playerTimes)

    for (let i = 0; i < uniquePlayingTime.size - 1; i++) {
      if (highestPlayersArr[i]?.uuid.includes(player?.uuid)) setHasHighTime(true)
      else setHasHighTime(false)
    }
  }, [currentLineUp])

  useEffect(() => {
    const playerTimerEl = playerTimerRef.current
    const playingTime = playerWithTime?.playingTime ? Math.round(playerWithTime.playingTime / 60) : 0
    const timerValue = (playingTime / matchLength) * 100
    const degrees = Math.round((360 / 100) * timerValue)

    playerTimerEl.style.setProperty('--player-timer-filled', `${degrees}deg`)
    playerTimerEl.style.setProperty('--player-timer-empty', `${360 - degrees}deg`)
  }, [playerWithTime?.playingTime])

  return <div ref={playerTimerRef} className={`PlayerTimer ${hasHighTime ? 'PlayerTimer-hightime' : ''}`}></div>
}

PlayerTimer.defaultPropTypes = {
  player: {},
  matchLength: 0
}

PlayerTimer.propTypes = {
  player: PropTypes.object,
  matchLength: PropTypes.number
}

export default PlayerTimer
